import { Box, Grid, Skeleton } from '@mui/material';
import React, { FC } from 'react';

//Скелетон карточки товара в строку
const ListCatalogCardSkeleton: FC = () => {
  return (
    <Grid sx={{ display: 'grid', marginTop: '8px' }} rowGap={1} item xs={12} sm={6} md={12} lg={12}>
      <Box sx={{ display: 'grid', rowGap: '8px' }}>
        <Box sx={{ display: 'flex', columnGap: '8px' }}>
          <Box sx={{ width: '20%' }}>
            <Skeleton animation="wave" variant="rounded" width="100%" height="100%" /> {/* Image */}
          </Box>

          <Box sx={{ display: 'grid', columnGap: '8px', rowGap: '10px', width: '80%' }}>
            <Skeleton animation="wave" variant="rounded" width="100%" height={39} /> {/* Name */}
            <Skeleton animation="wave" variant="rounded" width="20%" height={32} /> {/* Price */}
            <Box sx={{ display: 'flex', columnGap: '8px' }}>
              <Skeleton animation="wave" variant="rounded" width="30%" height={36} /> {/* Add in favorites */}
              <Skeleton animation="wave" variant="rounded" width="70%" height={36} /> {/* Add in basket */}
            </Box>
          </Box>
        </Box>
        <Box>
          <Skeleton animation="wave" variant="rounded" width="100%" height={37} /> {/* Vendor */}
        </Box>
      </Box>
    </Grid>
  );
};

export default ListCatalogCardSkeleton;
